// src/pages/Settings/settingsTabContext.js
//
// Bridges the :activeTab URL segment (owned by Settings/index.js) to any
// SettingsPanel rendered inside a settings panel, so a panel's tab is
// deep-linkable via /settings/:mainTopTab/:activeMenu/:activeTab without each
// of the ~45 panels wiring react-router itself.
//
//   { subTab, setSubTab }
//     subTab    — the current :activeTab URL segment (string) or null
//     setSubTab — updates it; Settings/index.js pushes the new URL
//
// Provided by Settings/index.js, consumed by components/SettingsPanel.jsx.
// Defaults to null so a SettingsPanel rendered outside the settings frame
// keeps working with plain value/onChange state.

import { createContext } from "react";

export const SettingsSubTabContext = createContext(null);
